import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { useId } from '@nerdwallet/react-accessibility';
import { printDeprecationWarning } from '@nerdwallet/deprecate';
import ModalImpl, { DialogStateContext } from './modal-impl';
import ModalContent from './modal-content';
import useDeprecatedReactModalProps from './use-deprecated-react-modal-props';

var Modal = function Modal(props) {
  var _useDeprecatedReactMo = useDeprecatedReactModalProps(props, 'Modal'),
      children = _useDeprecatedReactMo.children,
      onRequestBack = _useDeprecatedReactMo.onRequestBack,
      onRequestClose = _useDeprecatedReactMo.onRequestClose,
      shouldShowBack = _useDeprecatedReactMo.shouldShowBack,
      shouldShowSecurityMessage = _useDeprecatedReactMo.shouldShowSecurityMessage,
      subtitle = _useDeprecatedReactMo.subtitle,
      title = _useDeprecatedReactMo.title,
      titleElementIdProp = _useDeprecatedReactMo.titleElementId,
      bodyOpenClassName = _useDeprecatedReactMo.bodyOpenClassName,
      modalImplProps = _objectWithoutProperties(_useDeprecatedReactMo, ["children", "onRequestBack", "onRequestClose", "shouldShowBack", "shouldShowSecurityMessage", "subtitle", "title", "titleElementId", "bodyOpenClassName"]); // autogenerate titleElementId if not provided


  var titleElementId = useId(titleElementIdProp);
  return /*#__PURE__*/React.createElement(ModalImpl // spread remaining props directly onto ModalImpl
  , _extends({}, modalImplProps, {
    // modal is always centered and scrollable
    isCentered: true,
    isScrollable: true // legacy support for managed modals (imagine a "Confirm Close" dialog)
    ,
    onRequestClose: onRequestClose // specifically tie-in ModalContent title
    ,
    "aria-labelledby": modalImplProps['aria-labelledby'] || titleElementId
  }), /*#__PURE__*/React.createElement(DialogStateContext.Consumer, null, function (_ref) {
    var setVisible = _ref.setVisible;
    return /*#__PURE__*/React.createElement(ModalContent, {
      className: classes('margin-vertical-5--wide'),
      shouldShowSecurityMessage: shouldShowSecurityMessage,
      onRequestBack: onRequestBack,
      onRequestClose: onRequestClose || function () {
        return setVisible(false);
      },
      shouldShowBack: shouldShowBack,
      subtitle: subtitle,
      title: title,
      titleElementId: titleElementId
    }, children);
  }));
};
/**
 * Only here for backwards-compatibility.  That was a passthrough to: http://reactcommunity.org/react-modal/accessibility/#app-element
 * @deprecated
 */


Modal.setAppElement = function () {
  printDeprecationWarning({
    message: 'Modal.setAppElement has been deprecated and is now a NOOP. Please remove the callsites from your app. It will be removed in the next major version'
  });
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Modal.propTypes = _objectSpread(_objectSpread({}, ModalImpl.propTypes), {}, {
    /**
     * Run after the modal's back button is clicked.
     */
    onRequestBack: PropTypes.func,

    /**
     * Flag to indicate if the encryption security message should be added to the modal.
     */
    shouldShowSecurityMessage: PropTypes.bool,

    /**
     * Indicates if the back button should be shown.
     */
    shouldShowBack: PropTypes.bool,

    /**
     * unique id for the title's dom element. If not provided, an autogenerated id will be used.
     */
    titleElementId: PropTypes.string,

    /**
     * The title text of the modal
     */
    title: PropTypes.string,

    /**
     * The subtitle text of the modal
     */
    subtitle: PropTypes.string,

    /**
     * Additional ARIA attributes. This could be extended for more support
     * @deprecated
     */
    aria: PropTypes.shape({
      labelledby: PropTypes.string
    }),

    /**
     * Duration for modal visual animations
     * @deprecated
     */
    closeTimeoutMS: PropTypes.number,

    /**
     * How the content container should be announced to screen readers
     * @deprecated
     */
    contentLabel: PropTypes.string,

    /**
     * Will be run after the modal has opened.
     * @deprecated
     */
    onAfterOpen: PropTypes.func
  });
}

Modal.defaultProps = {
  // ModalContent defaults
  onRequestBack: function onRequestBack(f) {
    return f;
  },
  shouldShowBack: false,
  shouldShowSecurityMessage: false,
  subtitle: null,
  title: null,
  titleElementId: null,
  // [DEPRECATED] - all props below this line should not be used.
  aria: undefined,
  contentLabel: undefined,
  onAfterOpen: undefined
};
export default Modal;